import React, { useState } from "react";
import react from "../Assets/react.png";

import node from "../Assets/node.png";
import adobe from "../Assets/adobe.png";
import css from "../Assets/css.png";
import html from "../Assets/html.png";
import js from "../Assets/js.png";
import mysql from "../Assets/mysql.png";
import sass from "../Assets/sass.png";
import ps from "../Assets/ps.png";
import git from "../Assets/git.png";
import mongo from "../Assets/mongo.png";
import ionic from "../Assets/ionic.png";
import reactnative from "../Assets/reactnative.png";
import electron from "../Assets/electron.svg";
import nextjs from "../Assets/nextjs.png";
import tauri from "../Assets/tauri.png"


function Skills(props) {
  const [skills] = useState([
   
    react,
    adobe,
    css,
    html,
    js,
    mysql,
    sass,
    ps,
    node,
    git,
    mongo, 
      reactnative,
    ionic,
 
    nextjs,
 tauri
  
  ]);

  return (
    <div id="skills">
      <section className="icon" data-aos="zoom-in-right">
        {skills.map((skill) => (
          <img src={skill} alt="" />
        ))}

        <embed src={electron} type="" />
      </section>

      <section className="skillabout">
        <section className="skhr">
          <hr className="hori" /> MY SKILLS
        </section>
        <h3>Language {"&"} Tools</h3>
        <p>
         
        </p>
      </section>
    </div>
  );
}

export default Skills;
